<template>
  <div id="contentWrap">
    <div class="BackHeader">
      <div class="backWrap" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        <div class="backTitle">F10 资料</div>
      </div>
    </div>
    <div class="mainPage">
      <div class="typeArea">
        <div class="firstWrap">
          <div class="activeFirst commodityInfo">
            <p>{{ commodityCode }}</p>
            <span class="line"></span>
            <p>{{ item }}</p>
          </div>
        </div>
        <div class="secondWrap">
          <div v-for="item in list" :key="item.id" :class="item.className" @click="getData(item.id)">
            {{ item.name }}
          </div>
        </div>
        <div class="bottomWrap">
          <div class="textWrap">
            <div v-if="title == '商品信息'" class="right" v-html="data.information"></div>
            <div v-if="title == '上市公告'" class="right" v-html="data.publicAnnouncement"></div>
            <div v-if="title == '交收标准'" class="right" v-html="data.deliveryStandards"></div>
            <div v-if="title == '仓库信息'" class="right" v-html="data.warehouseVideo"></div>
            <div v-if="title == '交收可替代品信息'" class="right" v-html="data.deliveryAlternative"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol*/
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      data: {},
      commodityId: null, // 商品id
      commodityCode: '',
      title: '上市公告',
      list: [
        {
          id: 0,
          name: '上市公告',
          className: 'activeSecond'
        },
        {
          id: 1,
          name: '商品信息',
          className: ''
        },
        {
          id: 2,
          name: '交收标准',
          className: ''
        },
        {
          id: 3,
          name: '仓库信息',
          className: ''
        },
        {
          id: 4,
          name: '交收可替代品信息',
          className: ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'sessionInfoGetter'
    ]),
    /* eslint-disable vue/no-side-effects-in-computed-properties */
    item() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        this.commodityCode = this.$store.state.hqData.item.commodityCode
        this.commodityId = Number(this.$store.state.hqData.item.symbolId)
        return this.$store.state.hqData.item.symbol
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          this.commodityCode = this.$store.state.hqData.marketDetails[0].commodityCode
          this.commodityId = Number(this.$store.state.hqData.marketDetails[0].symbolId)
          return this.$store.state.hqData.marketDetails[0].symbol
        } else {
          this.commodityCode = '--'
          return '--'
        }
      }
    },
    isLogin() {
      if (
        this.sessionInfoGetter &&
        this.sessionInfoGetter['sessionStr'] &&
        this.sessionInfoGetter['userId']
      ) {
        return true
      }
      return false
    }
  },
  watch: {
    item() {
      this.getCommInfo()
    }
  },
  mounted() {
    if (this.commodityId) {
      this.getCommInfo()
    }
  },
  methods: {
    getCommInfo() {
      protocol.param_findCommodityDetail.param.commodityId = this.commodityId
      http.postFront(protocol.param_findCommodityDetail).then(response => {
        const { code, value, message } = response.data
        if (Number(code) === 0) {
          this.data = value.content[0]
        } else {
          this.$message(message)
        }
      })
    },
    goBack() {
      if (this.isLogin) {
        this.$router.push('/transcc')
      } else {
        this.$router.push('/transccless')
      }
    },
    getData(id) {
      this.list.forEach(item => {
        item.className = ''
      })
      this.list[id].className = 'activeSecond'
      this.title = this.list[id].name
    }
  }
}
</script>
<style lang="scss" scoped>
#contentWrap {
  min-height: 100vh;
  min-width: 900px;
  background-color: #fff;
  .BackHeader {
    min-width: 1200px;
    padding: 17px 0 17px 40px;
    background-color: #000000;
    .backWrap {
      cursor: pointer;
      display: flex;
      align-items: center;
      font-family: Source Han Sans SC;
      font-weight: bold;
      font-size: 20px;
      color: #FFFFFF;
      .backTitle {
        margin-left: 10px;
      }
    }
  }
  .commodityInfo {
    display: flex;
    align-items: center;
    .line {
      display: inline-block;
      width: 2px;
      height: 20px;
      background: #000000;
      margin:  0 20px;
    }
  }
  .centerWrap {
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 43px 0 18px 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .item {
      margin-right: 73px;
      p {
        cursor: pointer;
        font-family: Source Han Sans SC;
        font-weight: bold;
        font-size: 18px;
        color: #999999;
      }
      p:hover {
        color: #333333;
      }
    }
  }
  .bottomWrap {
    padding: 80px 48px;
    min-height: calc(100vh - 460px);
    .textWrap {
      .right{
        width: 100%;
      }
    }
  }
}
</style>
